export default "__VITE_ASSET__8382ac41__"